export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const BRAND = {
  name: "New Boogie Woogie Academy",
  tagline: "Where talent finds direction and passion becomes performance.",
  phone: "9334153470",
  phoneLink: "tel:+919334153470",
  phoneDisplay: "+91 93341 53470",
  whatsapp: "9334046453",
  whatsappDisplay: "+91 93340 46453",
  email: "manitanil215@gmail.com",
  hours: "Sunday to Monday — 6:00 AM to 8:00 PM",
  instagram1: "https://www.instagram.com/anilraj00732?stkn=Z3JkYWU0amJxaTA2",
  instagram2: "https://www.instagram.com/newboogiewoogieacademy1?stkn=MTI3eHRibGZ6bmxnNA==",
  facebook: "https://www.facebook.com/share/1GhuGGbAGh/",
  youtube: "https://youtube.com/@boogiewoogieacademy?si=feJA2VSTVdwWLvWp",
};

export const waLink = (msg) =>
  `https://wa.me/919334046453?text=${encodeURIComponent(
    msg || "Hello New Boogie Woogie Academy, I would like to enquire about your activities/classes."
  )}`;

export const BRANCHES = [
  {
    id: "main",
    name: "Main Branch",
    label: "BRANCH 01",
    address: "Rajendra Path, RK Bhattacharya Rd, Patna, Bihar 800001",
    maps: "https://maps.app.goo.gl/JJsqiwss3tXcr6go9",
  },
  {
    id: "second",
    name: "Second Branch",
    label: "BRANCH 02",
    address: "Shop No 2, Gupta Complex, Road No. 1, New Jakkanpur, Gardanibagh, Patna, Bihar 800001",
    maps: "https://maps.app.goo.gl/q8PuB8PZavPmNyN58?g_st=aw",
  },
];

const U = (url, w = 1200) =>
  url.includes("unsplash.com") ? `${url}&w=${w}&auto=format` : url;

export const IMAGES = {
  hero: U("https://images.pexels.com/photos/8820330/pexels-photo-8820330.jpeg?auto=compress&cs=tinysrgb&w=1600"),
  aboutStudio: U("https://images.unsplash.com/photo-1508807526345-15e9b5f4eaff?crop=entropy&cs=srgb&fm=jpg&q=85"),
  contemporary: U("https://images.unsplash.com/photo-1529229504105-4ea795dcbf59?crop=entropy&cs=srgb&fm=jpg&q=85"),
  hiphop: U("https://images.unsplash.com/photo-1508700929628-666bc8bd84ea?crop=entropy&cs=srgb&fm=jpg&q=85"),
  western: U("https://images.pexels.com/photos/3022420/pexels-photo-3022420.jpeg?auto=compress&cs=tinysrgb&w=940"),
  kathak: U("https://images.pexels.com/photos/30481585/pexels-photo-30481585.jpeg?auto=compress&cs=tinysrgb&w=940"),
  bollywood: U("https://images.unsplash.com/photo-1547106510-6aec13ee41ff?crop=entropy&cs=srgb&fm=jpg&q=85"),
  semiclassical: U("https://images.pexels.com/photos/33638407/pexels-photo-33638407.jpeg?auto=compress&cs=tinysrgb&w=940"),
  zumba: U("https://images.unsplash.com/photo-1518611012118-696072aa579a?crop=entropy&cs=srgb&fm=jpg&q=85"),
  aerobics: U("https://images.unsplash.com/photo-1518310383802-640c2de311b2?crop=entropy&cs=srgb&fm=jpg&q=85"),
  yoga: U("https://images.unsplash.com/photo-1506126613408-eca07ce68773?crop=entropy&cs=srgb&fm=jpg&q=85"),
  guitar: U("https://images.unsplash.com/photo-1758466872393-57aad0d6512b?crop=entropy&cs=srgb&fm=jpg&q=85"),
  singing: U("https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?crop=entropy&cs=srgb&fm=jpg&q=85"),
  painting: U("https://images.pexels.com/photos/36736772/pexels-photo-36736772.jpeg?auto=compress&cs=tinysrgb&w=940"),
  gymnastics: U("https://images.unsplash.com/photo-1566241142559-40e1dab266c6?crop=entropy&cs=srgb&fm=jpg&q=85"),
  karate: U("https://images.unsplash.com/photo-1555597673-b21d5c935865?crop=entropy&cs=srgb&fm=jpg&q=85"),
  modelling: U("https://images.unsplash.com/photo-1509631179647-0177331693ae?crop=entropy&cs=srgb&fm=jpg&q=85"),
  acting: U("https://images.unsplash.com/photo-1460723237483-7a6dc9d0b212?crop=entropy&cs=srgb&fm=jpg&q=85"),
  birthday: U("https://images.unsplash.com/photo-1513151233558-d860c5398176?crop=entropy&cs=srgb&fm=jpg&q=85"),
  sangeet: U("https://images.pexels.com/photos/26558728/pexels-photo-26558728.jpeg?auto=compress&cs=tinysrgb&w=940"),
  eventDecor: U("https://images.pexels.com/photos/12688989/pexels-photo-12688989.jpeg?auto=compress&cs=tinysrgb&w=940"),
  stage: U("https://images.unsplash.com/photo-1470225620780-dba8ba36b745?crop=entropy&cs=srgb&fm=jpg&q=85"),
  stageSpotlight: U("https://images.pexels.com/photos/4250534/pexels-photo-4250534.jpeg?auto=compress&cs=tinysrgb&w=940"),
  stage2: U("https://images.pexels.com/photos/8285998/pexels-photo-8285998.jpeg?auto=compress&cs=tinysrgb&w=940"),
  training: U("https://images.unsplash.com/photo-1545205597-3d9d02c29597?crop=entropy&cs=srgb&fm=jpg&q=85"),
  moment: U("https://images.unsplash.com/photo-1535525153412-5a42439a210d?crop=entropy&cs=srgb&fm=jpg&q=85"),
  class1: U("https://images.unsplash.com/photo-1524594152303-9fd106c212d3?crop=entropy&cs=srgb&fm=jpg&q=85"),
  class2: U("https://images.unsplash.com/photo-1518834107812-67b0b7c58434?crop=entropy&cs=srgb&fm=jpg&q=85"),
};

export const ASSETS = {
  logo: "/assets/logo.png",
  ritiRiwaz: "/assets/riti-riwaz.jpg",
  mrsBeautyMom: "/assets/mrs-beauty-mom.jpg",
  studio1: "/assets/studio-1.jpg",
  studio2: "/assets/studio-2.jpg",
  studio3: "/assets/studio-3.jpg",
  studio4: "/assets/studio-4.jpg",
  studio5: "/assets/studio-5.jpg",
  stage1: "/assets/stage-1.jpg",
  stage2: "/assets/stage-2.jpg",
  stage3: "/assets/stage-3.jpg",
  event1: "/assets/event-1.jpg",
  event2: "/assets/event-2.jpg",
  event3: "/assets/event-3.jpg",
  event4: "/assets/event-4.jpg",
  video2: "/assets/academy-video-2.mp4",
  video2Poster: "/assets/video-2-poster.jpg",
  video: "/assets/academy-video-full.mp4",
};

export const CATEGORIES = [
  "Dance",
  "Fitness & Wellness",
  "Music & Creative Arts",
  "Performance & Personal Development",
];

export const ACTIVITIES = [
  { slug: "western-dance", name: "Western Dance", cat: "Dance", img: IMAGES.western, desc: "High-energy western styles that build rhythm, flexibility, style and stage confidence." },
  { slug: "hip-hop", name: "Hip-Hop", cat: "Dance", img: IMAGES.hiphop, desc: "Street-style foundations, freestyle, isolations and choreography with attitude and control." },
  { slug: "contemporary", name: "Contemporary", cat: "Dance", img: IMAGES.contemporary, desc: "Expressive movement blending technique, emotion, flow and storytelling through the body." },
  { slug: "semi-classical", name: "Semi-Classical", cat: "Dance", img: IMAGES.semiclassical, desc: "A graceful fusion of classical grace with modern expression, rhythm and elegance." },
  { slug: "kathak", name: "Classical — Kathak", cat: "Dance", img: IMAGES.kathak, desc: "The classical art of Kathak — footwork, spins, abhinaya and timeless Indian tradition." },
  { slug: "bollywood-dance", name: "Bollywood Dance", cat: "Dance", img: IMAGES.bollywood, desc: "Filmy energy, expressions and crowd-winning choreography to your favourite tracks." },
  { slug: "zumba", name: "Zumba", cat: "Fitness & Wellness", img: IMAGES.zumba, desc: "Dance-fitness sessions that burn calories, lift mood and keep every workout fun." },
  { slug: "aerobics", name: "Aerobics", cat: "Fitness & Wellness", img: IMAGES.aerobics, desc: "Structured cardio routines for stamina, toning and all-round fitness." },
  { slug: "yoga", name: "Yoga", cat: "Fitness & Wellness", img: IMAGES.yoga, desc: "Asanas, breathing and mindfulness for flexibility, balance and inner calm." },
  { slug: "guitar", name: "Guitar", cat: "Music & Creative Arts", img: IMAGES.guitar, desc: "From first chords to full songs — structured guitar training for every level." },
  { slug: "singing", name: "Singing", cat: "Music & Creative Arts", img: IMAGES.singing, desc: "Vocal training that builds pitch, range, control and confident performance." },
  { slug: "painting", name: "Painting", cat: "Music & Creative Arts", img: IMAGES.painting, desc: "Creative art classes that develop imagination, technique and self-expression." },
  { slug: "gymnastics", name: "Gymnastics", cat: "Performance & Personal Development", img: IMAGES.gymnastics, desc: "Strength, flexibility, balance and body control through disciplined practice." },
  { slug: "karate", name: "Karate", cat: "Performance & Personal Development", img: IMAGES.karate, desc: "Martial arts training that builds discipline, focus, fitness and self-defence." },
  { slug: "modelling", name: "Modelling — All Ages, Male & Female", cat: "Performance & Personal Development", img: IMAGES.modelling, desc: "Ramp walk, posture, grooming and camera confidence for aspiring models of all ages." },
  { slug: "acting", name: "Acting", cat: "Performance & Personal Development", img: IMAGES.acting, desc: "Theatre and screen acting — dialogue, expression, presence and character work." },
];

export const DIFFERENTIATORS = [
  { icon: "ShieldCheck", title: "Discipline & Dedication", desc: "We maintain a disciplined and focused learning environment where students are encouraged to be punctual, respectful, consistent, and dedicated to their practice." },
  { icon: "Handshake", title: "Trust & Reliability", desc: "We believe in building strong, long-term relationships with students and parents through honest communication, professionalism, and dependable training." },
  { icon: "Layers", title: "Proper & Structured Classes", desc: "Every class is conducted in an organized and structured manner, focusing on technique, rhythm, coordination, expressions, creativity, and performance skills." },
  { icon: "Clock", title: "Punctual & Available Teachers", desc: "Our teachers strive to be punctual, prepared, and available for scheduled classes and activities across different categories, providing guidance whenever students need support." },
  { icon: "Sparkles", title: "Overall Development", desc: "We encourage students to develop confidence, discipline, teamwork, creativity, stage presence, and self-expression alongside their skills." },
  { icon: "TrendingUp", title: "Consistency That Builds Progress", desc: "We encourage regular practice and gradual improvement rather than rushing the learning process." },
  { icon: "Sun", title: "Positive & Energetic Environment", desc: "We aim to create a welcoming environment where students can learn without hesitation, enjoy their training, express themselves, and develop confidence." },
  { icon: "UserCheck", title: "Student-Focused Approach", desc: "Every student has their own pace, strengths, and learning journey. We aim to understand individual needs and provide encouragement throughout the learning process." },
];

export const REETI_REEWAJ = [
  "Anchoring", "Rock Band", "Track Singing", "Wedding Bride & Groom Entry",
  "Sangeet Choreography", "Mehendi Choreography", "Anniversary Choreography",
  "Haldi Performances", "Group Dance Performances",
];

export const BIRTHDAY_SERVICES = [
  "Rock Band", "Singing", "Anchoring", "Track Singing",
  "Dance Performances", "Decoration", "Birthday Boy/Girl Entry",
];

export const GOOGLE_REVIEWS = [
  {
    name: "Garima Singh",
    title: "Best Dance Class",
    text: "It's been almost few months and i realized that this is the best place where i can learn every form of dance. The faculty's the instructor and the infrastructure is so good..all are so hardworking and cooperative..i have learnt a lot and looking forward to get some more. :) :)",
  },
  { name: "Gungun Drolia", title: null, text: "Really best 👍💯 dance 💃 class of patna" },
  { name: "Vandana Jha", title: null, text: "This is really the best dance class in Patna" },
  { name: "Ravi Kriti Sharma", title: null, text: "Best dance class" },
];

export const PORTFOLIO_ITEMS = [
  { img: ASSETS.stage1, cat: "Stage Shows", caption: "On stage — academy performers" },
  { img: ASSETS.stage2, cat: "Stage Shows", caption: "Live stage performance" },
  { img: ASSETS.stage3, cat: "Stage Shows", caption: "Stage appearance" },
  { img: ASSETS.studio1, cat: "Academy Moments", caption: "Inside the academy — the performance wall" },
  { img: ASSETS.studio2, cat: "Academy Moments", caption: "Inside the academy — mirrored training hall" },
  { img: ASSETS.studio3, cat: "Academy Moments", caption: "Inside the academy — signature neon wall" },
  { img: ASSETS.studio4, cat: "Academy Moments", caption: "Inside the academy — the main hall" },
  { img: ASSETS.studio5, cat: "Academy Moments", caption: "Inside the academy — celebration decor" },
  { img: ASSETS.studio3, video: ASSETS.video, type: "video", cat: "Performances", caption: "Academy in motion — watch the video" },
  { img: ASSETS.event1, cat: "Academy Moments", caption: "Academy event moment" },
  { img: ASSETS.event2, cat: "Stage Shows", caption: "On-stage moment" },
  { img: ASSETS.event3, cat: "Stage Shows", caption: "Event highlight" },
  { img: ASSETS.event4, cat: "Academy Moments", caption: "Recognition moment on stage" },
  { img: ASSETS.video2Poster, video: ASSETS.video2, type: "video", cat: "Performances", caption: "Academy in motion — more from the stage" },
];

export const GALLERY_ITEMS = [
  { img: ASSETS.studio1, cat: "Academy Moments", caption: "Inside the academy — the performance wall" },
  { img: ASSETS.stage1, cat: "Stage Shows", caption: "On stage — academy performers" },
  { img: ASSETS.studio2, cat: "Academy Moments", caption: "Inside the academy — mirrored training hall" },
  { img: ASSETS.stage2, cat: "Stage Shows", caption: "Live stage performance" },
  { img: ASSETS.studio3, cat: "Academy Moments", caption: "Inside the academy — signature neon wall" },
  { img: ASSETS.studio4, cat: "Academy Moments", caption: "Inside the academy — the main hall" },
  { img: ASSETS.stage3, cat: "Stage Shows", caption: "Stage appearance" },
  { img: ASSETS.studio5, cat: "Academy Moments", caption: "Inside the academy — celebration decor" },
  { img: ASSETS.studio3, video: ASSETS.video, type: "video", cat: "Performances", caption: "Academy in motion — watch the video" },
  { img: ASSETS.event1, cat: "Academy Moments", caption: "Academy event moment" },
  { img: ASSETS.event2, cat: "Stage Shows", caption: "On-stage moment" },
  { img: ASSETS.event3, cat: "Stage Shows", caption: "Event highlight" },
  { img: ASSETS.event4, cat: "Academy Moments", caption: "Recognition moment on stage" },
  { img: ASSETS.video2Poster, video: ASSETS.video2, type: "video", cat: "Performances", caption: "Academy in motion — more from the stage" },
];

export const NAV_LINKS = [
  { name: "Home", path: "/" },
  { name: "About", path: "/about" },
  { name: "Activities", path: "/activities" },
  { name: "Events", path: "/events" },
  { name: "Portfolio", path: "/portfolio" },
  { name: "Gallery", path: "/gallery" },
  { name: "Reviews", path: "/reviews" },
  { name: "Booking", path: "/booking" },
  { name: "Careers", path: "/careers" },
  { name: "Contact", path: "/contact" },
];

export const FAQS = [
  {
    q: "What age groups can join New Boogie Woogie Academy?",
    a: "We welcome learners from 4+ years to 40 years, across all genders. Every student learns at their own pace with guidance from our teachers.",
  },
  {
    q: "Which activities does the academy offer in Patna?",
    a: "We offer dance (Western, Hip-Hop, Contemporary, Semi-Classical, Kathak, Bollywood), fitness (Zumba, Aerobics, Yoga), music and creative arts (Guitar, Singing, Painting), performance training (Gymnastics, Karate, Modelling, Acting), along with event and entertainment services.",
  },
  {
    q: "How do I book a class or make an enquiry?",
    a: "You can book an appointment or send an enquiry through our website, call us at +91 93341 53470, or message us on WhatsApp at +91 93340 46453. Our team will get in touch with you shortly.",
  },
];
